<template>
  <div class="tw-w-full form-group">
    <div class="tw-flex tw-justify-between tw-mb-2">
      <span>
        {{ field.title }}
      </span>
    </div>
    <div class="tw-flex tw-gap-[30px]">
      <b-form-select v-model="orderModel" :options="orderOptions" class="tw-w-1/2" />
      <b-form-select v-model="fieldModel" :options="fieldOptions" class="tw-w-1/2" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    field: {
      type: Object,
      default: () => null,
    },
    fieldKey: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      localValue: "",
      localOrder: "desc",
      localField: "amount",
    };
  },

  created() {
    this.syncFromValue(this.value);
  },

  watch: {
    value(val, old) {
      if (val !== old) {
        this.syncFromValue(val);
      }
    },
    localOrder() {
      this.emitCombined();
    },
    localField() {
      this.emitCombined();
    },
  },

  computed: {
    value() {
      return this.form[this.fieldKey];
    },

    orderOptions() {
      return [
        { value: "asc", text: this.$t("edit_campaign.schema_donors_widget_vue_asc", "Asc") },
        { value: "desc", text: this.$t("edit_campaign.schema_donors_widget_vue_desc", "Desc") },
      ];
    },

    fieldOptions() {
      return [
        {
          value: "amount",
          text: this.$t("edit_campaign.schema_donors_widget_vue_amount", "Amount"),
        },
        { value: "time", text: this.$t("edit_campaign.schema_donors_widget_vue_time", "Date") },
      ];
    },

    orderModel: {
      get() {
        return this.localOrder;
      },
      set(val) {
        this.localOrder = val;
      },
    },

    fieldModel: {
      get() {
        return this.localField;
      },
      set(val) {
        this.localField = val;
      },
    },
  },

  methods: {
    syncFromValue(v) {
      // Normalize and parse existing sort_by value into two controls
      const value = typeof v === "string" ? v : "";
      const isDesc = value.startsWith("-");
      const core = value.replace(/^-/, "");

      if (core === "amount" || core === "time") {
        this.localField = core || "amount";
        this.localOrder = isDesc ? "desc" : "asc";
      } else {
        // Fallback to defaults
        this.localField = "amount";
        this.localOrder = "desc";
      }

      this.emitCombined();
    },

    emitCombined() {
      const combined = this.localOrder === "desc" ? `-${this.localField}` : this.localField;
      this.$emit("input", combined);
    },
  },
};
</script>
